const AESUtil = (() => {

    const KEY = "1234567890abcdef"; // 必须和后端一致
    const IV = "abcdef1234567890";

    function strToUint8(str) {
        return new TextEncoder().encode(str);
    }

    function uint8ToStr(arr) {
        return new TextDecoder().decode(arr);
    }

    function base64Encode(bytes) {
        let binary = "";
        bytes.forEach(b => binary += String.fromCharCode(b));
        return btoa(binary);
    }

    function base64Decode(base64) {
        let binary = atob(base64);
        let bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
        }
        return bytes;
    }

    async function getKey() {
        return crypto.subtle.importKey(
            "raw",
            strToUint8(KEY),
            { name: "AES-CBC" },
            false,
            ["encrypt", "decrypt"]
        );
    }

    async function encrypt(content) {
        const key = await getKey();

        const encrypted = await crypto.subtle.encrypt(
            {
                name: "AES-CBC",
                iv: strToUint8(IV)
            },
            key,
            strToUint8(content)
        );

        return base64Encode(new Uint8Array(encrypted));
    }

    async function decrypt(base64Content) {
        const key = await getKey();

        const decrypted = await crypto.subtle.decrypt(
            {
                name: "AES-CBC",
                iv: strToUint8(IV)
            },
            key,
            base64Decode(base64Content)
        );

        return uint8ToStr(new Uint8Array(decrypted));
    }

    return {
        encrypt,
        decrypt
    };

})();

export default AESUtil